import React, { useState } from 'react';
import { Modal, Radio, Input, Space, Typography } from 'antd';

const { Text } = Typography;

const TIMEFRAME_OPTIONS = [
  { label: '0-3 Months', value: '0-3months' },
  { label: '3-6 Months', value: '3-6months' },
  { label: '6-12 Months', value: '6-12months' },
  { label: 'Custom', value: 'custom' },
];

const TimeframeModal = ({ open, templateTitle, onConfirm, onCancel }) => {
  const [timeframe, setTimeframe] = useState('0-3months');
  const [timeframeCustom, setTimeframeCustom] = useState('');

  const handleOk = () => {
    onConfirm({
      timeframe,
      timeframe_custom: timeframe === 'custom' ? timeframeCustom : null,
    });
    setTimeframe('0-3months');
    setTimeframeCustom('');
  };

  const handleCancel = () => {
    setTimeframe('0-3months');
    setTimeframeCustom('');
    onCancel();
  };

  return (
    <Modal
      title="Select Timeframe"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Place Recommendation"
      width={400}
    >
      <Space direction="vertical" style={{ width: '100%' }}>
        <Text>
          When should <strong>{templateTitle}</strong> be implemented?
        </Text>
        <Radio.Group
          value={timeframe}
          onChange={(e) => setTimeframe(e.target.value)}
          optionType="button"
          buttonStyle="solid"
          options={TIMEFRAME_OPTIONS}
        />
        {timeframe === 'custom' && (
          <Input
            placeholder="e.g., After Q2 audit"
            value={timeframeCustom}
            onChange={(e) => setTimeframeCustom(e.target.value)}
          />
        )}
      </Space>
    </Modal>
  );
};

export default TimeframeModal;
